import { render, staticRenderFns } from "./hpElectricity.vue?vue&type=template&id=2abbc53a&scoped=true&"
import script from "./hpElectricity.vue?vue&type=script&lang=js&"
export * from "./hpElectricity.vue?vue&type=script&lang=js&"
import style0 from "./hpElectricity.vue?vue&type=style&index=0&id=2abbc53a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abbc53a",
  null
  
)

export default component.exports